<script lang="ts">
import { PropType, VNode, defineComponent, h } from 'vue';

import { Nullable } from '@/utils/types';

import Label from '@/bundles/Common/components/Label.vue';

// Web links open in a new tab; tel: and mailto: hand off to the device instead.
const isWebHref = (href: string): boolean => /^(https?:)?\/\//.test(href);

export default defineComponent({
  name: 'CustomFieldValue',

  props: {
    value: {
      type: [String, Number] as PropType<Nullable<string | number>>,
      default: null,
    },
    href: {
      type: String as PropType<Nullable<string>>,
      default: null,
    },
  },

  // Parent class/listeners fall through to the single root (the link, or Label's span).
  render (): VNode {
    if (!this.href) {
      return h(Label, { value: this.value });
    }

    const newTabAttrs = isWebHref(this.href) ? { target: '_blank', rel: 'noopener noreferrer' } : {};

    return h('a', { href: this.href, ...newTabAttrs }, String(this.value));
  },
});
</script>
